<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <small class="text-muted">Marketing Campaign Name</small>
            <p class="fw-bold" style="font-size: large">
              {{ campaign.campaign_name }}
            </p>
            <hr class="custom-hr mb-3" />
            <div class="row">
              <div class="col d-flex flex-column custom-right-border">
                <small class="text-muted">Order Number</small>
                <small class="fw-bold">{{ campaign.order_no }}</small>
              </div>
              <div class="col d-flex flex-column custom-right-border">
                <small class="text-muted">Collaterals Count</small>
                <small class="fw-bold">{{ campaign.collateral_count }}</small>
              </div>
              <div class="col d-flex flex-column custom-right-border">
                <small class="text-muted">Store Count</small>
                <small class="fw-bold">{{ campaign.store_count }}</small>
              </div>
              <!-- <div class="col d-flex flex-column custom-right-border">
                <small class="text-muted">For Holding</small>
                <small class="fw-bold"
                  >PHP {{ (campaign.total_amount).toLocaleString() }}</small
                >
              </div>
              <div class="col d-flex flex-column">
                <small class="text-muted">Total Release</small>
                <small class="fw-bold">PHP 0</small>
              </div> -->
            </div>
            <hr class="custom-hr mt-3 mb-2" />
            <div class="d-flex flex-row align-items-center pt-2">
              <div class="mdi mdi-domain me-3" style="font-size: 27px"></div>
              <div>Self Fulfilled</div>
              <div class="ms-auto">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="viewCollaterals(campaign.id)"
                  >Collateral List</b-button
                >
                <!-- <router-link :to="{ path: `my-space/campaign/${campaign.id}/collaterals` }">
                </router-link> -->
              </div>
            </div>
          </div>
        </div>

        <b-row class="mb-2 d-flex flex-row align-items-center">
          <div sm class="mt-2 fw-bold">
              <label class="fs-5">Store List</label>
              <b-badge pill class="cstm-badge fs-6">{{
                campaign.store_count
              }}</b-badge>
          </div>
        </b-row>

        <b-tabs content-class="mt-3" nav-class="nav-tabs-custom" active-nav-item-class="bg-transparent">
          <b-tab title="All" active></b-tab>
          <b-tab title="Pending Collaterals" disabled></b-tab>
          <b-tab title="Active" disabled></b-tab>
          <b-tab title="Completed" disabled></b-tab>
          <!-- <b-tab title="Declined" disabled></b-tab> -->
        </b-tabs>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row">
              <b-form-group
                description="Search Keyword"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="custom-search-icon">
                        <i class="bx bx-search-alt-2"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      class="rounded-0 custom-input"
                      v-model="search.keyword"
                      type="search"
                      placeholder="Search here..."
                      @keydown.enter.prevent="showComingSoon"
                    ></b-form-input>
                  </b-input-group>
                </form>
              </b-form-group>
              <b-form-group
                description="Filter by Placement"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-form-select
                    v-model="search.placement"
                    class="form-select shadow-none"
                    :options="statusFilter"
                    @change="showComingSoon"
                  >
                  </b-form-select>
                </form>
              </b-form-group>
              <b-form-group
                description="Filter by Collaterals"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-form-select
                    v-model="search.collateral"
                    class="form-select shadow-none"
                    :options="statusFilter"
                    @change="showComingSoon"
                  >
                  </b-form-select>
                </form>
              </b-form-group>

              <div class="ms-auto">
                <b-button class="me-2" style="height: fit-content;" @click="showComingSoon">
                  <div class="mdi mdi-format-list-bulleted" ></div>
                </b-button>
  
                <b-button variant="primary" style="height: fit-content;">
                  <div class="mdi mdi-grid" ></div>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  v-if="list.length > 0" class="listing-container col-12">
      <b-row class="w-100">
        <b-col sm="12" md="6" lg="4" xl="4" :key="index" v-for="(item, index) in list" class="mb-4">
          <grid-item v-model="list[index]"/>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
// import Swal from "sweetalert2";
import appConfig from "@/app.config";
import {
  layoutMethods,
  layoutComputed,
  campaignMethods,
  campaignComputed,
} from "@/state/helpers";
import GridItem from "@/views/pages/my-space/grid-item";

/**
 * Users list component
 */
export default {
  page: {
    title: "Campaigns",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      // title: "User",
      //   campaign: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: ["name", "role"],
      sortBy: "id",
      sortDesc: false,
      search: {
        keyword: "",
        status: null,
      },
      fields: [
        {
          key: "marketing_campaign_name",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "order_number",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "status",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "total_balance",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "total_release",
          sortable: false,
          tdClass: "align-middle",
        },
        {
          key: "fulfilled",
          sortable: false,
          tdClass: "align-middle",
        },
      ],
      campaignNameFilter: [{ text: "All", value: null }],
      statusFilter: [{ text: "All", value: null }],
      submitted: false,
      campaignTotalRows: 0,
      list: []
    };
  },
  components: {
    GridItem
  },
  computed: {
    ...layoutComputed,
    ...campaignComputed,
  },
  async mounted() {
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "My Space", to: {} },
        { text: "Marketing Campaign Details", to: {} },
      ],
    });
    this.changeBackButton({
      value: true,
    });
    this.changePrevRoute({
      name: "campaigns",
      params: {},
    });
    this.getCampaign({ id: this.$route.params.id }).then(() => {
      this.list = this.campaign.stores;
    });
    // get the module access for checking if user has create, read, update, and/or delete access
    // await getModuleAccess("Settings", "User Management", "Roles").then(
    //   (access) => (this.rolesModule.access = access)
    // );
  },
  methods: {
    ...layoutMethods,
    ...campaignMethods,
    viewCollaterals(campaignId) {
      this.$router.push({
        path: `/my-space/campaign-details/${campaignId}/collaterals`,
      });
    },
    showComingSoon() {
      this.$toast.showToast('info', 'Coming Soon!', 'Stay tuned for this feature.');
    }
  },
};
</script>

<style scoped>
.cstm-badge {
  color: #fff;
  background-color: #0062ff;
  border-radius: 10px;
  margin-left: 10px;
}

.table {
  --bs-table-bg: transparent;
}

.table th {
  background-color: #f5f6f8;
}

.custom-search-icon {
  font-size: 1.5rem;
  background-color: transparent;
  border-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

.custom-input {
  border-left: 0;
  border-radius: 0px 5px 5px 0px !important;
}

.table td {
  width: 400px;
}

.form-check-input {
  border-color: #7e93a059;
}

.underline-offset {
  text-decoration: underline;
  text-underline-offset: 11px;
  text-decoration-thickness: 2px;
  color: #f84b04;
}

.custom-hr {
  border: solid 1px #e1e1e1 !important;
}

.custom-fg-width {
  width: 300px;
}

.custom-right-border {
  border-right: solid #e1e1e1 1px;
}
</style>
